import { createAuthClient } from 'better-auth/react';
import { organizationClient } from 'better-auth/client/plugins';
import { env } from '@/app/env';

/**
 * better-auth client for the PLATFORM instance.
 *
 * The backend runs a separate better-auth instance per app, each with its own
 * secret, its own tables (`users`/`sessions` here, `admin_users`/`admin_sessions`
 * for admin) and its own cookie/token config. This client must therefore stay
 * app-local: never lift it into a shared package, and never point it at the
 * admin origin.
 *
 * Auth uses **bearer tokens, not cookies** (backend decision, 2026-08-08), so
 * the token returned on sign-in is stored via `@/lib/session` and attached by
 * `@/api/client`.
 *
 * NOTE: nothing in the UI calls this yet — the auth module ships as screens
 * only. Wiring sign-in/sign-out/invitation acceptance to these methods is the
 * first real task after the scaffold.
 */
export const authClient = createAuthClient({
  baseURL: `${env.apiBaseUrl}/v1/auth`,
  plugins: [
    // Agencies, members, invitations and seat limits are all modelled by the
    // organization plugin on the backend.
    organizationClient(),
  ],
});

export type AuthClient = typeof authClient;
